module.exports = __webpack_public_path__ + "img/Artboard – 8.f481fbbc.png";